import { useInstance } from 'intact-vue-next';
import { useDraggable as useBaseDraggable } from '../../hooks/useDraggable';
import { scrollbarWidth } from '../position';
export function useDraggable(dialogRef, areaRef) {
  var component = useInstance();
  var x = 0;
  var y = 0;
  var width = 0;
  var height = 0;
  var areaWidth = 0;
  var areaHeight = 0;
  function onStart(e) {
    var dialog = dialogRef.value;
    x = dialog.offsetLeft - e.clientX;
    y = dialog.offsetTop - e.clientY;
    width = dialog.offsetWidth;
    height = dialog.offsetHeight;
    var body = document.body;
    var html = document.documentElement;
    if (!component.get('overlay')) {
      areaWidth = Math.max(body.scrollWidth, html.scrollWidth);
      areaHeight = Math.max(body.scrollHeight, html.scrollHeight);
    } else {
      areaWidth = Math.max(html.offsetWidth, window.innerWidth);
      areaHeight = Math.max(html.offsetHeight, window.innerHeight);
    }
  }
  function onMove(e) {
    var style = dialogRef.value.style;
    var _areaWidth = areaWidth;
    var area = areaRef.value;
    if (area) {
      // detect the wrapper has scrollbar or not
      if (area.scrollHeight > area.offsetHeight) {
        var scrollBarWidth = scrollbarWidth();
        _areaWidth -= scrollBarWidth;
      }
    }
    var left = Math.min(Math.max(x + e.clientX, 0), Math.max(_areaWidth - width, 0));
    var top = Math.min(Math.max(y + e.clientY, 0), Math.max(areaHeight - height, 0));
    style.left = left + "px";
    style.top = top + "px";
  }
  return useBaseDraggable({
    onStart: onStart,
    onMove: onMove,
    disable: function disable() {
      return !component.get('draggable');
    }
  });
}